import { Button } from '@/components/ui/button';
import { Users, Monitor, Calendar } from 'lucide-react';

const roomImages = [
  'https://images.unsplash.com/photo-1568865439677-aa00c4826dc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbWVldGluZyUyMHJvb20lMjBnbGFzcyUyMHdhbGxzfGVufDB8fHx8MTc2ODk2NjYwN3ww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1763412050485-d7e1688f8858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMG9mZmljZSUyMG1lZXRpbmclMjBzcGFjZSUyMHBsYW50c3xlbnwwfHx8fDE3Njg5NjY2MDl8MA&ixlib=rb-4.1.0&q=85'
];

export default function RoomCard({ room, onBook, imageIndex }) {
  return (
    <div
      data-testid={`room-card-${room.id}`}
      className="relative overflow-hidden rounded-2xl group cursor-pointer h-[380px] shadow-lg hover:shadow-xl transition-all duration-300"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={roomImages[imageIndex % roomImages.length]}
          alt={room.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col justify-between p-8">
        {/* Top Badge */}
        <div className="flex justify-end">
          <div className="px-4 py-2 rounded-full bg-white/20 backdrop-blur-md border border-white/30">
            <span className="text-white text-sm font-mono font-medium">
              {room.capacity} pessoas
            </span>
          </div>
        </div>

        {/* Bottom Content */}
        <div className="space-y-6">
          <div>
            <h3 className="text-3xl font-manrope font-bold text-white tracking-tight mb-3">
              {room.name}
            </h3>
            <div className="flex flex-wrap gap-2">
              {room.equipment.slice(0, 3).map((item, idx) => (
                <span
                  key={idx}
                  className="text-xs px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white font-inter"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          <Button
            data-testid={`book-room-button-${room.id}`}
            onClick={() => onBook(room)}
            className="w-full bg-white/90 hover:bg-white text-primary hover:text-primary/90 rounded-full h-12 font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all backdrop-blur-sm"
          >
            <Calendar className="w-4 h-4 mr-2" />
            Reservar Sala
          </Button>
        </div>
      </div>
    </div>
  );
}